import { RootState } from '../../model/model'

export const dislikeSelector = (state: RootState) => state.dislike

export const dislikeItemsSelector = (state: RootState) => state.dislike.items
